export default __webpack_public_path__ + "static/media/fm-logo-dark.667ce6a8.svg";